module.exports = __webpack_public_path__ + "img/audio.96b77559.svg";